import React from "react";
import DataItem from "../Components/DataItem";

import ReasonForm from "../Forms/ReasonForm";

export default class UnusedBuses extends React.Component {

    constructor(){
        super();
        this.state = {
            trips: [],
            reasonFormOpen: false,
            noShowIndex: null
        }
    }

    componentDidMount(){
        console.log("UNUSED BUSES PROPS", this.props.data);
        this.setData();
    }

    componentDidUpdate(prevProps) {
        if(this.props.data !== this.state.trips){
            this.setData();
        }
    }

    setData() {
        this.setState({trips: this.props.data});
    }

    noshow = (index) => {
        this.setState({reasonFormOpen: true, noShowIndex: index});
    }

    runNoShowWithReason = (reason) => {
        const index = this.state.noShowIndex;
        console.log("REASON AND INDEX?", reason, index);
        this.setState({reasonFormOpen: false, noShowIndex: null});
        this.props.noShow(index, reason);
    }

    render() {

        // console.log("UNUSED OPEN FORM FUNCTION", this.props.openForm);

        return (
            <>
            {this.props.data 
                ? this.state.trips.map((bus, index) => {
                    return <UnusedBusRecord bus={bus} index={index} key={index} openForm={this.props.openForm} switchTrips={this.props.switchTrips} noshow={this.noshow} />
                })
                : null
            }
            {
                this.state.reasonFormOpen
                ? <ReasonForm submitReason={this.runNoShowWithReason} />
                : null
            }
            </>
        )
    }
}

const UnusedBusRecord = (props) => {

    const timeIndex = props.bus.SchedDepTime.indexOf(" ");
    const time = props.bus.SchedDepTime.substr(timeIndex);

    const switchSelect = (index, isUnfilled) => {
        props.switchTrips(index, props.index, isUnfilled, true);
    }

    const noshow = () => {
        const prompt = window.confirm("Are you sure you want to mark this bus as a no show?");
        if(prompt){
            props.noshow(props.index);
        }
    }

    //#dd8888

    return (
        <div className="data trip-card shadow-card" 
        style={{backgroundColor: "rgb(245 195 146)", color:"#444"}}>
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "larger",
                backgroundColor: "#ddd"
            }}>
                <i className="fas fa-bus"></i>
            </div>
            <div className="trip-inner-grid" style={{
                alignItems: "center",
                gridRowGap: "8px"
            }}>
                <div>
                    Run: <DataItem val={props.bus.run_id_original} />
                    {
                            props.bus.DelayReason === "NoShow"
                            ? <></>
                            :
                            <span onClick={(evt) => props.openForm(evt, props.index, switchSelect, true)}
                                style= {{
                                    marginLeft: "1vw",
                                    backgroundColor: "white",
                                    padding: "0.1vw 1.3vw",
                                    borderRadius: "10px"
                                }}
                                className="reassign-button"
                            >
                                <i className="fas fa-random"></i>
                            </span>
                    }
                </div>
                <div><DataItem val={time} /></div>
                <div style={{
                    gridRow: "1/3",
                    gridColumn: "3/4"
                }}>
                    {
                        props.bus.DelayReason === "NoShow"
                        ? <span>No Show</span>
                        : <button className="option" onClick={noshow}>No Show</button>
                    }
                </div>
                <div>Dest: <DataItem val={props.bus.Header} /></div>
                <div>Bus#: <DataItem val={props.bus.vehicle_id_original} /></div>
                <div>L/G: <DataItem val={props.bus.SchedLaneGate} /></div>
                <div>Return: <DataItem val={props.bus.return_trip_time} /></div>
            </div>
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-evenly",
                fontWeight: "bold",
                backgroundColor: "#ddd",
                padding: "0.2vh 0 0.5vh 0"
            }}>
                <span>
                    Bus
                </span>
                <span>
                    Not
                </span>
                <span>
                    Used
                </span>
            </div>
        </div>
    )
}